export const FILTERS_AMOUNT_TO_SHOW_SEARCHER = 8;
